import type { Chain, PlacerEntityResponse } from '@placer-ui/types';
import { fetchWrapper } from 'API/authentification/fetch-wrapper';

export const competitorAPI = {
    getChainCompetitorById(id: string): PlacerEntityResponse<Chain[]> {
        return fetchWrapper({ targetUrl: `/chains/${id}/competitors?limit=1` });
    },
};
